import { DYNAMIC_FORM_CONTROL_TYPE_ARRAY, DYNAMIC_FORM_CONTROL_TYPE_GROUP } from '@ng-dynamic-forms/core';
import { TYPE_DATA_ARRAY } from '../dynamic-form-components/data-array/data-array.model';
import { AnyFormControlModel } from '../dynamic-form-components/shared-models/any-form-control.model';

export function setModelDisabled(
  model: AnyFormControlModel[],
  disabled: boolean,
  config: { excludeIds?: string[]; excludeModel?: (AnyFormControlModel) => boolean } = {}
) {
  model.forEach(controlModel => {
    // added "typeof config.excludeModel === 'function'" since compiler wants an additional type safety check here
    if (!config.excludeIds?.includes(controlModel.id) && !(config && typeof config.excludeModel === 'function' && config.excludeModel(controlModel))) {
      controlModel.disabled = disabled;
    }
    if (controlModel.type === DYNAMIC_FORM_CONTROL_TYPE_GROUP) {
      setModelDisabled(controlModel.group, disabled, config);
    } else if (controlModel.type === DYNAMIC_FORM_CONTROL_TYPE_ARRAY) {
      controlModel.groups.forEach(groupModel => {
        setModelDisabled(groupModel.group, disabled, config);
      });
    }
  });
}

export function getDisabledIds(model: AnyFormControlModel[]): string[] {
  return model.reduce((disabledIds: string[], controlModel: AnyFormControlModel) => {
    if (controlModel.disabled && !disabledIds.includes(controlModel.id)) {
      disabledIds.push(controlModel.id);
    }
    if (controlModel.type === DYNAMIC_FORM_CONTROL_TYPE_GROUP) {
      disabledIds.push(...getDisabledIds(controlModel.group));
    } else if (controlModel.type === DYNAMIC_FORM_CONTROL_TYPE_ARRAY) {
      controlModel.groups.forEach(groupModel => {
        disabledIds.push(...getDisabledIds(groupModel.group));
      });
    } else if (controlModel.type === TYPE_DATA_ARRAY) {
      disabledIds.push(...getDisabledIds(controlModel.groupPrototype));
    }
    return disabledIds;
  }, []);
}
